// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./static/pgnvjs/css/pgnvjs.min.css
// module id = 433
// module chunks = 11